export default class FormDelegate {
    constructor() {
        this.inputs = {};
        this.changeHandler = () => {};
        this.submitHandler = () => {};
    }

    registerInput(inputComponent) {
        const inputName = inputComponent.props.name;
        this._validateInput(inputComponent, 'register');
        this.inputs[inputName] = {
            component: inputComponent,
            name: inputName,
            touched: false,
            value: inputComponent.value
        }
        this.inputs[inputName].valid = this.checkValid(inputComponent);

        return () => {
            delete this.inputs[inputName];
        }
    }

    _validateInput(inputComponent, action = 'use') {
        if (!inputComponent.props.name) {
            throw new Error(`FormDelegate: Can't ${action} input without a name.`, {
                erroniousInput: inputComponent
            });
        }
    }

    updateInput(inputComponent) {
        const name = inputComponent.props.name;
        this._validateInput(inputComponent, 'update');

        if (this.inputs[name]) {
            Object.assign(this.inputs[name], {
                component: inputComponent,
                valid: this.checkValid(inputComponent),
                touched: true,
                value: inputComponent.value
            });
        }

        this.change();
    }

    touchAllInputs() {
        Object.keys(this.inputs).forEach(key => {
            let input = this.inputs[key];
            input.touched = true;
        });
    }

    generateOutput(){
        let result = {};
        Object.keys(this.inputs).forEach(key => {
            let input = this.inputs[key];
            if (input.valid) {
                result[key] = input.component.value
            }
        });

        return result;
    }

    getErrors() {
        let result = [];
        Object.keys(this.inputs).forEach(key => {
            let input = this.inputs[key];
            if (input.touched) {
                result = [
                    ...result,
                    ...input.errors
                ]
            }
        });

        return result;
    }

    checkValid(inputComponent) {

        if (!inputComponent.validators) {
            return true;
        }

        this.inputs[inputComponent.props.name].errors = [];

        return inputComponent.validators.every(validator => {
            if (validator) {
                let err = validator(inputComponent.value);
                if (err) {
                    this.inputs[inputComponent.props.name].errors.push(err);
                    return false;
                }

                return true;
            } else {
                return true;
            }
        });
    }

    isValid() {
        return Object.keys(this.inputs).every(key => {
            let input = this.inputs[key];
            return input.valid;
        });
    }

    get valid() {
        return this.isValid();
    }

    onChange(fn) {
        if (typeof fn !== 'function') {
            return;
        }

        this.changeHandler = fn;
    }

    change() {
        this.changeHandler(this.generateOutput(), this.isValid(), this.inputs);
    }

    onSubmit(fn) {
        if (typeof fn !== 'function') {
            return;
        }

        this.submitHandler = fn;
    }

    handleSubmit() {
        if (typeof this.submitHandler === 'function') {
            this.submitHandler(this.generateOutput(), this.isValid(), this.inputs);
        }
    }

    submit(event) {
        event.preventDefault();
        this.touchAllInputs();
        this.handleSubmit();
    }
}



// WEBPACK FOOTER //
// ./web-app/utils/form-delegate.js